import ProgressReport from './component';

import _routes from './routes';

export const routes = _routes;

export default ProgressReport;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/index.js